module.exports = __webpack_public_path__ + "img/Septris-sprite-level-bg.c8f80ecd.png";